export default __webpack_public_path__ + "static/media/Eleven.1fa88bd3.jpg";